import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { AuditLog } from '../types';
import axios from 'axios';

const backendUrl = 'http://localhost:3001/api';

interface AuditLogState {
  logs: AuditLog[];
}

const initialState: AuditLogState = {
  logs: [],
};

export const fetchAuditLogs = createAsyncThunk('audit/fetchAuditLogs', async () => {
    const response = await axios.get(`${backendUrl}/audit-logs`);
    return response.data.map((log: any) => ({ ...log, details: log.details ? JSON.parse(log.details) : undefined }));
});

export const logAction = createAsyncThunk('audit/logAction', async (log: Omit<AuditLog, 'id' | 'timestamp'>, { dispatch }) => {
    const response = await axios.post(`${backendUrl}/audit-logs`, log);
    dispatch(addLog(response.data));
    return response.data;
});

const auditLogSlice = createSlice({
  name: 'auditLog',
  initialState,
  reducers: {
    addLog: (state, action: PayloadAction<AuditLog>) => {
      state.logs.unshift(action.payload);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAuditLogs.fulfilled, (state, action: PayloadAction<AuditLog[]>) => {
        state.logs = action.payload;
    });
  },
});

export const { addLog } = auditLogSlice.actions;
export default auditLogSlice.reducer; 